var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label":_vm.i18nt('designer.setting.activeColor')}},[_c('el-color-picker',{model:{value:(_vm.optionModel.activeColor),callback:function ($$v) {_vm.$set(_vm.optionModel, "activeColor", $$v)},expression:"optionModel.activeColor"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }